import React from 'react';
import { Typography, Button, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const navigate = useNavigate();

  const actions = [
    { label: 'Create Campaign', path: '/campaigns/new' },
    { label: 'View Analytics', path: '/analytics' },
    { label: 'Manage Brands', path: '/brands' },
    { label: 'Partner Network', path: '/partners' }
  ];

  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="h6">
        Quick Actions
      </Typography>
      {actions.map((action, index) => (
        <Button
          key={index}
          variant="outlined"
          onClick={() => navigate(action.path)}
          fullWidth
        >
          {action.label}
        </Button>
      ))}
    </Box>
  );
};

export default QuickActions;
